import "./App.css";
import MainPage from "./Components/MainPage";
function App() {
  return (
    <div className="App">
      <MainPage />
      <div id="footer">
        <h4>Designed and build by Kunjan Ballawar @2024 All rights reserved.</h4>
      </div>
    </div>
  );
}
export default App;
